import React, { createContext, useContext, useLayoutEffect } from 'react';
import type { Me } from './authApi';
import UserMenu from './UserMenu';

export interface AccountMenuValue {
  me: Me;
  onAccess: () => void;
  onLogout: () => void;
  onLogoutAll: () => void;
  /** A header that renders the menu inline registers here; AuthGate then hides the floating fallback. */
  register: () => () => void;
}

/** Provided by AuthGate only while signed in (AUTH_MODE=session); null otherwise. */
export const AccountMenuContext = createContext<AccountMenuValue | null>(null);

/**
 * Account menu rendered INSIDE an app header (in the normal layout flow), so the
 * avatar never overlaps the header, its buttons or the cards below (the old fixed
 * top-right badge did). Renders nothing when auth is off.
 */
export const AccountMenuSlot: React.FC = () => {
  const account = useContext(AccountMenuContext);
  const register = account?.register;
  // Layout effect: AuthGate re-renders before paint, so the floating fallback never flashes.
  useLayoutEffect(() => register?.(), [register]);
  if (!account) return null;
  return (
    <UserMenu
      me={account.me}
      onAccess={account.onAccess}
      onLogout={account.onLogout}
      onLogoutAll={account.onLogoutAll}
      variant="inline"
    />
  );
};
